import axios from 'axios'
const proxyurl = "https://blooming-lake-03275.herokuapp.com/";
const BASE_URL="https://lonestar1.sofmen.com/super_admin/Api/"

const Api = axios.create({
    baseURL: proxyurl+BASE_URL
});
export default Api